import { useCallback } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

import { usePetitionPageUserLinkTracking } from '../tracking/usePetitionPageUserLinkTracking';

type UseUserProfileUrlResult = ModelHookResult<
	{
		isAnonymous: boolean;
		urlLink: string;
	},
	{
		onUserNameLinkClick: () => void;
	}
>;

export function useUserProfileUrl(): UseUserProfileUrlResult {
	const {
		data: {
			petition: {
				user: { id, slug, anonymous },
			},
		},
	} = usePetitionDetailsPageData();

	const { trackClick } = usePetitionPageUserLinkTracking();

	const onUserNameLinkClick = useCallback((): void => {
		trackClick();
	}, [trackClick]);

	const urlLink = `/u/${encodeURIComponent(slug || id)}`;

	return {
		data: {
			isAnonymous: anonymous,
			urlLink,
		},
		actions: {
			onUserNameLinkClick,
		},
	};
}
